import { Link } from "react-router-dom";
import { VisionerLogoWhite } from "@/components/VisionerLogo";
import { DotMatrixSVG } from "@/components/SVGElements";

const footerLinks = {
  services: [
    { name: "Civil Consultancy", href: "/services" },
    { name: "Structural Engineering", href: "/services" },
    { name: "Architectural Design", href: "/services" },
    { name: "Turnkey Construction", href: "/services" },
  ],
  company: [
    { name: "About Us", href: "/about" },
    { name: "Our Projects", href: "/projects" },
    { name: "Our Clients", href: "/clients" },
    { name: "Contact", href: "/contact" },
  ],
  locations: ["Delhi", "Gurugram", "Noida", "Faridabad", "Ghaziabad"],
};

const Footer = () => {
  return (
    <footer className="bg-slate-900 relative">
      {/* SVG Dot Pattern */}
      <div className="absolute inset-0 text-white opacity-10">
        <DotMatrixSVG />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Main Footer */}
        <div className="py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <VisionerLogoWhite size="small" />
            </Link>
            <p className="text-slate-400 font-manrope leading-relaxed mb-6">
              Shaping the Future, Structuring the Present. Your trusted partner
              for comprehensive civil, structural, and architectural solutions.
            </p>
            <div className="flex gap-4">
              {["facebook", "linkedin", "twitter", "instagram"].map((social) => (
                <a
                  key={social}
                  href={`#${social}`}
                  className="w-10 h-10 bg-slate-800 hover:bg-orange-500 flex items-center justify-center transition-colors"
                  data-testid={`footer-social-${social}`}
                >
                  <span className="sr-only">{social}</span>
                  <svg
                    className="w-4 h-4 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 2C6.477 2 2 6.477 2 12c0 5.523 4.477 10 10 10s10-4.477 10-10c0-5.523-4.477-10-10-10z" />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-oswald text-lg font-semibold text-white mb-6 uppercase tracking-wider">
              Services
            </h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-slate-400 hover:text-orange-500 font-manrope transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-oswald text-lg font-semibold text-white mb-6 uppercase tracking-wider">
              Company
            </h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-slate-400 hover:text-orange-500 font-manrope transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Locations */}
          <div>
            <h4 className="font-oswald text-lg font-semibold text-white mb-6 uppercase tracking-wider">
              Our Presence
            </h4>
            <ul className="space-y-2">
              {footerLinks.locations.map((location, index) => (
                <li key={location} className="flex items-center gap-2">
                  <span className="text-orange-500 text-xs font-bold">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="text-slate-400 font-manrope">{location}</span>
                </li>
              ))}
              <li className="text-slate-500 font-manrope text-sm mt-2">
                + 5 more cities
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm font-manrope">
            © {new Date().getFullYear()} Visioner Consultants Pvt Ltd. All rights
            reserved.
          </p>
          <div className="flex items-center gap-6">
            <button className="text-slate-500 hover:text-slate-400 text-sm font-manrope transition-colors">
              Privacy Policy
            </button>
            <button className="text-slate-500 hover:text-slate-400 text-sm font-manrope transition-colors">
              Terms of Service
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
